import React, { createContext, useContext, useReducer, useEffect } from 'react';

const CartStateContext = createContext();
const CartDispatchContext = createContext();
const STORAGE_KEY = 'hr_cart';

function loadFromStorage() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : { items: [] };
  } catch {
    return { items: [] };
  }
}

function cartReducer(state, action) {
  switch (action.type) {
    case 'ADD': {
      const { id, qty } = action.payload;
      const existing = state.items.find((i) => i.id === id);
      if (existing) {
        return {
          ...state,
          items: state.items.map((i) => (i.id === id ? { ...i, qty: i.qty + qty } : i)),
        };
      }
      return { ...state, items: [...state.items, { id, qty }] };
    }
    case 'REMOVE': {
      const { id } = action.payload;
      return { ...state, items: state.items.filter((i) => i.id !== id) };
    }
    case 'UPDATE': {
      const { id, qty } = action.payload;
      return { ...state, items: state.items.map((i) => (i.id === id ? { ...i, qty } : i)) };
    }
    case 'CLEAR':
      return { ...state, items: [] };
    default:
      return state;
  }
}

export function CartProvider({ children }) {
  const [state, dispatch] = useReducer(cartReducer, undefined, loadFromStorage);

  // Persistir en localStorage cada vez que el carrito cambie
  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch {}
  }, [state]);

  const actions = {
    addToCart:      (id, qty = 1) => dispatch({ type: 'ADD',    payload: { id, qty } }),
    removeFromCart: (id)          => dispatch({ type: 'REMOVE', payload: { id } }),
    updateQty:      (id, qty)     => dispatch({ type: 'UPDATE', payload: { id, qty } }),
    clearCart:      ()            => dispatch({ type: 'CLEAR' }),
  };

  return (
    <CartDispatchContext.Provider value={actions}>
      <CartStateContext.Provider value={state}>{children}</CartStateContext.Provider>
    </CartDispatchContext.Provider>
  );
}

export function useCartState() {
  const ctx = useContext(CartStateContext);
  if (!ctx) throw new Error('useCartState must be used within CartProvider');
  return ctx;
}

export function useCart() {
  const actions = useContext(CartDispatchContext);
  const state = useContext(CartStateContext);
  if (!actions || !state) throw new Error('useCart must be used within CartProvider');
  // convenience helpers
  const totalItems = state.items.reduce((s, it) => s + it.qty, 0);
  return { ...actions, items: state.items, totalItems };
}
